import { ReactNode } from 'react';
import React from 'react';
import styles from './TariffsTableBlock.module.scss';
import { ImportantIcon } from '../Icons/ImportantIcon.js';
import { Popup } from '@/npm/popup.js';

interface Props {
  isTariffsPage?: boolean;
  children?: ReactNode;
}

const popupContentStyle = {
  background: 'white',
  borderRadius: 12,
  boxShadow: '0px 10px 30px rgba(63, 169, 245, 0.1)',
  width: '100%',
  maxWidth: 360,
  padding: '1rem',
};

const TariffsTableBlock: React.FC<Props> = ({ children, isTariffsPage }) => (
  <div className={styles.container}>
    <p>Оплата производится победителем закупки*</p>

    <div className={styles.tableContainer}>
      <table>
        <thead>
          <tr>
            <th>{isTariffsPage ? 'Условия закупки' : '№\u00A0лота'}</th>
            {/* <th>
              С&nbsp;подпиской
              <br />
              на&nbsp;6&nbsp;месяцев
            </th>
            <th>
              С&nbsp;подпиской
              <br />
              на&nbsp;12&nbsp;месяцев
            </th> */}
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  </div>
);

export default TariffsTableBlock;
